import React, { ChangeEvent, FocusEvent, KeyboardEvent } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import InputWithLabel from '@ui-parts/InputWithLabel';
import { Controller } from 'react-hook-form';
import Button from '@ui-elements/Button';
import { FONT_SIZES, FONT_WEIGHTS, PALETTE, Z_INDEX } from '~/assets/styles/base';

import { originalFormSurveyTitleValidationRule } from '~/constants/validationRules';
import { ROUTES } from '~/constants/routes';

type Props = {
  handleChangeSurveyTitle: (e: ChangeEvent<HTMLInputElement>) => void;
  handleBlurSurveyTitle: (e: FocusEvent<HTMLInputElement>) => void;
  handleOnEnterKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
  registerForm: any;
};

const ContentBox = styled.div`
  width: 100%;
  padding: 35px;
  border: 1px solid ${PALETTE.border.frame};
  border-top: none;
  background: ${PALETTE.white};
`;

const ButtonBox = styled.div`
  margin-top: 20px;
  text-align: right;
`;
const RegisterSurveyTab: React.FC<Props> = ({
  handleChangeSurveyTitle,
  handleBlurSurveyTitle,
  handleOnEnterKeyDown,
  registerForm,
}: Props): JSX.Element => {
  const { t } = useTranslation();
  return (
    <ContentBox>
      <Controller
        name="surveyName"
        control={registerForm.control}
        rules={originalFormSurveyTitleValidationRule}
        render={({ field: { onChange, onBlur, value, name, ref }, fieldState: { error } }) => {
          const inputProps = {
            label: t('registration.originalForm.manual.inputBox.surveyName'),
            name,
            type: 'text',
            value,
            description: t('registration.originalForm.manual.inputBox.desc'),
            errorMessage: error?.message,
            width: '890px',
            textAlign: 'left',
            warnText: t('appCommon.forbiddenText'),
            warnRight: '10px',
            warnBottom: '80px',
            warnBackground: `${PALETTE.secondary.subButton}`,
            warnBorder: `${`1px solid ${PALETTE.border.frame}`}`,
            warnBorderRadius: '30px',
            warnLink: ROUTES.COMMON.FORBIDDEN_TEXT,
            fontWeight: FONT_WEIGHTS.size1,
            inputFontSize: FONT_SIZES.body3,
            handleChange: (e: ChangeEvent<HTMLInputElement>) => {
              onChange(e);
              handleChangeSurveyTitle(e);
            },
            handleBlur: (e: FocusEvent<HTMLInputElement>) => {
              onBlur();
              handleBlurSurveyTitle(e);
            },
            handleOnKeyDown: (e: KeyboardEvent<HTMLInputElement>) => {
              handleOnEnterKeyDown(e);
            },
            required: true,
            error: Boolean(error),
            errorZIndex: Z_INDEX.tooltip,
            dataTestId: 'User-SurveyRegister-Title',
            inputProps: { maxLength: 50 },
            position: 'centerAbsolute',
          };
          return <InputWithLabel {...inputProps} ref={ref} />;
        }}
      />
      <ButtonBox>
        <Button sx={{ width: 148 }} color="primary" variant="contained" type="submit">
          {t('appCommon.next')}
        </Button>
      </ButtonBox>
    </ContentBox>
  );
};

export default RegisterSurveyTab;
